module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_19_A_1.dd80db2c.mp3";